"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalESShort = void 0;
var LegalESShort = /** @class */ (function () {
    function LegalESShort() {
        this.legalText = 'Express shipping ';
        this.shortLegalLinkLabel = 'See details';
    }
    return LegalESShort;
}());
exports.LegalESShort = LegalESShort;
//# sourceMappingURL=legalESshort.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeliveryInfoWLS/legalESshort.cms.js
// module id = 1990
// module chunks = 8